var disableModal = false;

if(Function('/*@cc_on return document.documentMode===10@*/')()){ jQuery("html").addClass("ie10"); }

(function($) {

  $(document).ready(function(){

    /************************************** Set a cookie if user clicks no thanks to newsletter popup */ 
    var modalResult = readCookie('anne');

    if(modalResult) {
      disableModal = true;
    }

    $('.md-cookie').click(function(){
      createCookie('anne', 'disablemodal', 1);
    });

    /************************************** Banner Slick Slider -> Books Slider */ 
    if($('.book-slider').length) {
      $('.book-slider').slick({
        focusOnSelect: false,
        dots: true,
        arrows: false
      });
    }

    /************************************** Homepage Slick Slider -> Books Feed */ 
    // Launch slick slider for book feed
    if($('.autoplay').length) {
      $('.autoplay').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        cssEase: 'ease-out',
        prevArrow: '.book-feed-left',
        nextArrow: '.book-feed-right',
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
        

    /************************************** Mobile Navigation */ 
    $(".mobile-navigation ul").html($("#menu-main-menu").html());

    $(".nav-trigger").click(function(){
        if ($(".mobile-navigation").hasClass("expanded")) {
            $(".mobile-navigation.expanded").removeClass("expanded");
            $(this).removeClass("open");
        } else {
            $(".mobile-navigation").addClass("expanded");
            $(this).addClass("open");
        }
    }); 

    $('.dropdown-trigger').click(function(e){
      e.preventDefault();
      $(this).toggleClass('on').parent().next('.dropdown').toggleClass('on');
    });


    var grid = document.querySelector('.grid-container');
    var msnry = new Masonry( grid, {
      // options...
      itemSelector: '.item',
      columnWidth: 300
    });


  });


  /************************************** Complete cookie script -> do not show if cookie has been set */ 
  $(window).load(function(){
    if($('.md-modal').length && disableModal === false) {
      setTimeout(function(){
        $('.md-modal').addClass('md-show');
      }, 7000);
    }
  });


})(jQuery); // Fully reference jQuery after this point.


/************************************** http://www.quirksmode.org/js/cookies.html */
function createCookie(name,value,days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
}

/************************************** http://www.quirksmode.org/js/cookies.html */
function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

/************************************** http://www.quirksmode.org/js/cookies.html */
function eraseCookie(name) {
    createCookie(name,"",-1);
}
